import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { Components } from 'react-markdown'

const mdComponents: Components = {
  h2: ({ children }) => (
    <h2
      style={{
        fontFamily: 'var(--font-sans)',
        fontWeight: 600,
        fontSize: 'var(--fs-body-lg)',
        color: 'var(--text-strong)',
        marginTop: 24,
        marginBottom: 8,
        paddingBottom: 6,
        borderBottom: '1px solid var(--border)',
      }}
    >
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3
      style={{
        fontFamily: 'var(--font-sans)',
        fontWeight: 600,
        fontSize: 'var(--fs-body)',
        color: 'var(--text-strong)',
        marginTop: 16,
        marginBottom: 4,
      }}
    >
      {children}
    </h3>
  ),
  p: ({ children }) => (
    <p
      style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-body)',
        color: 'var(--text-body)',
        lineHeight: 1.65,
        marginBottom: 12,
      }}
    >
      {children}
    </p>
  ),
  ul: ({ children }) => (
    <ul
      style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-body)',
        color: 'var(--text-body)',
        paddingInlineStart: 20,
        marginBottom: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        listStyleType: 'disc',
      }}
    >
      {children}
    </ul>
  ),
  ol: ({ children }) => (
    <ol
      style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-body)',
        color: 'var(--text-body)',
        paddingInlineStart: 20,
        marginBottom: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        listStyleType: 'decimal',
      }}
    >
      {children}
    </ol>
  ),
  li: ({ children }) => <li style={{ lineHeight: 1.65 }}>{children}</li>,
  strong: ({ children }) => (
    <strong style={{ fontWeight: 600, color: 'var(--text-strong)' }}>{children}</strong>
  ),
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'var(--brand)', textDecoration: 'none' }}
      onMouseEnter={(e) => ((e.target as HTMLAnchorElement).style.textDecoration = 'underline')}
      onMouseLeave={(e) => ((e.target as HTMLAnchorElement).style.textDecoration = 'none')}
    >
      {children}
    </a>
  ),
  em: ({ children }) => (
    <em style={{ fontStyle: 'italic', color: 'var(--text-muted)' }}>{children}</em>
  ),
}

export function Privacy() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div style={{ maxWidth: 600, margin: '0 auto' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '12px 16px',
          borderBottom: '1px solid var(--border)',
          background: 'var(--surface)',
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            display: 'flex',
            alignItems: 'center',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            color: 'var(--brand)',
            padding: 4,
          }}
        >
          <ChevronLeft size={22} />
        </button>
        <h1
          style={{
            margin: 0,
            fontFamily: 'var(--font-sans)',
            fontWeight: 700,
            fontSize: 'var(--fs-body-lg)',
            color: 'var(--text-strong)',
          }}
        >
          {t('privacy.title')}
        </h1>
      </div>

      <div style={{ padding: '24px 20px' }}>
        <ReactMarkdown remarkPlugins={[remarkGfm]} components={mdComponents}>
          {t('privacy.body')}
        </ReactMarkdown>
      </div>
    </div>
  )
}
